import { call, put, takeEvery } from 'redux-saga/effects';

import * as types from './constants';
import * as actions from './actions';
import { handleErrors, fetch } from '../../../../api';
import api from '../../../../api/endpoints';

function* handoffLookbookOrderShopify({ payload: { id, orderId, onSuccess, onError, handledErrors } }) {
  try {
    const { data } = yield call(fetch, { api: api.lookbooks.orders.handoffShopify, pathParams: { id, orderId } });

    onSuccess && onSuccess();
    yield put(actions.handoffLookbookOrderShopifyDone(data.result));
  } catch (error) {
    onError && onError();
    yield handleErrors({
      error,
      putErrorData: actions.handoffLookbookOrderShopifyFailed,
      handledErrors,
      endpoint: api.lookbooks.orders.handoffShopify.url
    });
  }
}

export const handoffLookbookOrderShopifySaga = takeEvery(types.HANDOFF_LOOKBOOK_ORDER_SHOPIFY_REQUEST, handoffLookbookOrderShopify);
